import { render } from "./LaboratoryList.vue?vue&type=template&id=574106f2&scoped=true"
import script from "./LaboratoryList.vue?vue&type=script&lang=js"
export * from "./LaboratoryList.vue?vue&type=script&lang=js"

import "./LaboratoryList.vue?vue&type=style&index=0&id=574106f2&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574106f2"]])

export default __exports__